import React from "react";
import styles from "./Boxes.module.scss";
import iconGroup from "../../../images/jpycPrepaidSymbol.min.svg";
import prepaidImg from "../../../images/prepaid.svg";
import giftImg from "../../../images/creditcard.png";

const BoxesSection = () => {
  return (
    <section className={styles.boxesWrapper}>
      <div className={styles.stableCoinBox}>
        <div className={styles.stableCoinBoxWrapper}>
          <img className={styles.iconGroup} src={iconGroup} alt="icon-group" />
          <h3 className={styles.stableTitle}>
            パブリックブロックチェーン上で作られた日本円建プリペイド型トークン
          </h3>
          <p className={styles.stableSubText}>
            Ethereum、Polygon、Gnosis、Shiden、Avalanche、Astarで発行しており、JPYC
            Appsで1JPYC Prepaid =1円として利用ができます。JPYC Prepaid はERC20規格のトークンのため、メタマスクなどのウォレットで個人で管理する必要があります。
          </p>
        </div>
      </div>
      <div className={styles.rightBox}>
        <div className={styles.prepaidBox}>
          <h3 className={styles.prepaidTitle}>
            暗号資産ではなく、<br />
            電子決済手段に該当する前払式支払手段
          </h3>
          <div className={styles.prepaidContent}>
            <div className={styles.prepaidTextWrapper}>
              <p className={styles.prepaidSubText}>
              2025年6月1日より、JPYC Prepaidは電子決済手段に該当する前払式支払手段となります。これに伴い、常に1JPYC Prepaid = 1円で、現金、預金、3か月未満の国債などの現金等価物と同様に、キャッシュフロー計算書上における「資金」として取扱いができます。
              </p>
            </div>
          </div>
        </div>
        <div className={styles.giftBox}>
          <div className={styles.giftBoxWrapper}>
            <img className={styles.giftImg} src={giftImg} alt="gift-img" />
            <div className={styles.giftTextWrapper}>
              <h3 className={styles.giftTitle}>
                JPYC Prepaid をVプリカギフトなどと交換して日常のお買物に使える
              </h3>
              <p className={styles.giftSubText}>
                JPYC Prepaid は、インターネット上のVisa加盟店なら世界中どこでもクレジットカードと同じように使えるＶプリカギフトなどと交換して日常のお買物に使うことができます。
                <br />
                ※3Dセキュアのご利用はVプリカアカウントへの登録が必要です。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BoxesSection;
